var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7157 3.36572L2.24068 8.28759C2.09193 8.32826 1.95932 8.4138 1.86094 8.53256C1.76255 8.65131 1.70316 8.79751 1.69087 8.95123C1.67857 9.10496 1.71396 9.25874 1.79221 9.39162C1.87047 9.52451 1.98779 9.63004 2.12818 9.69384L10.1532 13.4907C10.3104 13.5635 10.4366 13.6898 10.5094 13.847L14.3063 21.872C14.3701 22.0124 14.4756 22.1297 14.6085 22.2079C14.7414 22.2862 14.8952 22.3216 15.0489 22.3093C15.2026 22.297 15.3488 22.2376 15.4676 22.1392C15.5864 22.0408 15.6719 21.9082 15.7126 21.7595L20.6344 4.28447C20.6717 4.15695 20.674 4.02174 20.6411 3.89302C20.6082 3.7643 20.5412 3.64681 20.4473 3.55286C20.3533 3.45891 20.2359 3.39197 20.1071 3.35904C19.9784 3.32611 19.8432 3.32842 19.7157 3.36572V3.36572Z",
    stroke: "#524F4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3967 13.6027L14.6342 9.36523",
    stroke: "#524F4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.de3f81d12f65a221c1f76e9e142dc19c.svg";
export { ForwardRef as ReactComponent };